import React, { useState } from "react";
import { FlexColumn, FlexRow, Spacer } from "../../core/Containers";
import { Text } from "../../core/Text";
import { Image } from "../../core/Image";
import { CheckBox, RawInput } from "../../core/Forms";
import { classNames } from "../../helpers/ClassNames";
import { Images } from "../../assets/images/images";
import { Button, RawButton } from "../../core/Buttons";
import { RiDeleteBin6Line } from "react-icons/ri";
import { FaMinus, FaPlus } from "react-icons/fa";
import { OrderModal } from '../Modals/OrderModal';
import { CartModal } from "../Modals/CartModal";

export const PackageItem = ({ className, isSelected, data, onClick, list }) => {

  const isItemAdded = (pkgId) => {
    const getItemAdded = list.find(pkg => pkg.id === pkgId);
    return getItemAdded !== undefined;
  };

  return (
    <FlexColumn
      className={`items-center justify-between border-grey-400 rounded-lg shadow-lg border-2 ${isItemAdded(data.id) ? '' : 'hover:border-red-200'} p-2 ${isSelected ? 'border-red-400' : ''
        } ${isItemAdded(data.id) ? 'cursor-not-allowed' : ''} ${className}`}
      onClick={isItemAdded(data.id) ? null : () => onClick(data)}
    >
      <FlexRow className="w-full items-center">
        <Text
          className={`text-sm ${isSelected ? 'text-red-400' : 'text-secondary-200'
            }`}
        >
          {data.type}
        </Text>
        <CheckBox
          checked={isSelected}
          className={`phone:mx-0 ${isItemAdded(data.id) ? 'cursor-not-allowed' : ''
            }`}
          containerClass="ml-auto"
          id={data.name}
          name={data.name}
          label=""
          onClick={isItemAdded(data.id) ? null : () => onClick(data)}
          disabled={isItemAdded(data.id)}
        />
      </FlexRow>
      <Image alt={data.name} className="my-5" src={Images.getPackageImage(Number(data.id))} />
      <Text
        className={`${isItemAdded(data.id) ? 'text-grey-400' : 'text-secondary-100'
          } text-center font-bold`}
      >
        {data.name}
      </Text>
      <Text
        className={`${isItemAdded(data.id) ? 'text-grey-400' : 'text-secondary-100'
          } text-center`}
      >
        {data.dimension}
      </Text>
    </FlexColumn>
  );
};

export const CorpPortalAcctPackageItem = ({
  className,
  isSelected,
  data,
  onClick,
  isInch,
  disabled,
  isSendTipid,
}) => {
  const [cmToIN, setCMToIN] = React.useState(2.54);

  // SendTipid has its own product ids/images (e.g. prodId 45 is N-Pack Medium for SendTipid but
  // N-Pack Small for Corporate). Opt in explicitly so the Corporate and CAMS flows, which share
  // this component, keep resolving through the Corporate image map.
  const resolvePackageImage = (prodId) =>
    isSendTipid
      ? Images.getPackageImageSendTipid(Number(prodId))
      : Images.getPackageImage(Number(prodId));

  return (
    <>
      {!disabled ? (
        <FlexColumn
          className={`items-center justify-between border-grey-400 rounded-lg shadow-lg border-2 hover:border-red-200 p-2 ${isSelected ? "border-red-400 bg-red-70" : ""
            } ${className}`}
          onClick={() => onClick(data)}
        >
          <FlexRow className="w-full items-center">
            <Text
              className={`text-sm ${isSelected ? "text-red-400" : "text-secondary-200"
                }`}
            >
              {data.type}
            </Text>
            <CheckBox
              checked={isSelected}
              className="phone:mx-0"
              containerClass="ml-auto"
              id={`pkg-optn-${data.prodId}`}
              name="package"
              label=""
              value={data.prodDisplayName}
              onClick={() => onClick(data)}
            />
          </FlexRow>
          <Image
            alt={data.prodDisplayName}
            className="my-5 w-40 h-32"
            src={resolvePackageImage(data.prodId)}
          />
          <Text
            className="text-secondary-100 text-center font-bold"
          >
            {data.prodDisplayName}
          </Text>
          <Text
            className="text-secondary-100 text-center text-xs"
          >
            {(data.length > 0 || data.width > 0 || data.height > 0) ? (
              `${data.length > 0
                ? `${isInch ? data.length / cmToIN : data.length} x `
                : ""
              } ${data.width > 0
                ? `${isInch ? data.width / cmToIN : data.width} x `
                : ""
              } ${data.height > 0
                ? `${isInch ? data.height / cmToIN : data.height}`
                : ""
              } ${isInch ? "in" : "cm"}`) : (
              <>&nbsp;</>
            )}
          </Text>
          <Text
            className="text-secondary-100 text-center text-xs"
          >
            {data.weight > 0 || data.prodId === 16 ? (
              `Max weight: ${data.prodId === 16 ? 100.0 : data.weight
              } kg`
            ) : (
              <>&nbsp;</>
            )}
          </Text>
          <Spacer className="h-4" />
        </FlexColumn>
      ) : (
        <FlexColumn
          className={`items-center justify-between border-grey-400 rounded-lg shadow-lg border-2 p-2 ${isSelected ? "border-red-400 bg-red-70" : ""
            } cursor-not-allowed ${className}`}
        >
          <FlexRow className="w-full items-center">
            <Text
              className={`text-sm ${isSelected ? "text-red-400" : "text-secondary-200"
                }`}
            >
              {data.type}
            </Text>
            <CheckBox
              checked={isSelected}
              className="phone:mx-0"
              containerClass="ml-auto"
              id={`pkg-optn-${data.prodId}`}
              name="package"
              label=""
              value={data.prodDisplayName}
              disabled={disabled}
            />
          </FlexRow>
          <Image
            alt={data.prodDisplayName}
            className="my-5 w-40 h-32"
            src={resolvePackageImage(data.prodId)}
          />
          <Text
            className="text-grey-400 text-center font-bold"
          >
            {data.prodDisplayName}
          </Text>
          <Text
            className="text-grey-400 text-center text-xs"
          >
            {(data.length > 0 || data.width > 0 || data.height > 0) ? (
              `${data.length > 0
                ? `${isInch ? data.length / cmToIN : data.length} x `
                : ""
              } ${data.width > 0
                ? `${isInch ? data.width / cmToIN : data.width} x `
                : ""
              } ${data.height > 0
                ? `${isInch ? data.height / cmToIN : data.height}`
                : ""
              } ${isInch ? "in" : "cm"}`) : (
              <>&nbsp;</>
            )}
          </Text>
          <Text
            className="text-grey-400 text-center text-xs"
          >
            {data.weight > 0 || data.prodId === 16 ? (
              `Max weight: ${data.prodId === 16 ? 100.0 : data.weight
              } kg`
            ) : (
              <>&nbsp;</>
            )}
          </Text>
          <Spacer className="h-4" />
        </FlexColumn>
      )
      }
    </>
  );
};

// export const PackageCard = ({ image, title, size, weight, NCRPrice, OutSideNCR, Description }) => {
//   const [isModalOpen, setIsModalOpen] = useState(false);

//   const [isCartModalOpen, setIsCartModalOpen] = useState(false);
//   const [cartItems, setCartItems] = useState([]);

//   const handleAddToCart = (item) => {
//     setCartItems([...cartItems, item]); // Add item to cart
//     setIsModalOpen(false); // Close OrderModal
//     setIsCartModalOpen(true); // Open CartModal
//   };

//   const packageData = { image, prodDisplayName: title, NCRPrice, OutSideNCR, Description };

//   return (
//     <>

//       {/* <OrderModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} /> */}

//       <OrderModal 
//         isOpen={isModalOpen} 
//         onClose={() => setIsModalOpen(false)} 
//         onAddToCart={handleAddToCart} // Pass function to OrderModal
//         packageData={packageData}
//       />

//       <CartModal
//         open={isCartModalOpen}
//         setOpen={setIsCartModalOpen}
//         cartItems={cartItems}
//       />

//       <div className="relative bg-white rounded-xl p-4 shadow-lg text-center w-full max-w-[300px] group overflow-hidden">


//         <div className="relative">
//           <img src={image} alt={title} className="w-full h-[160px] object-contain mb-2" />
//         </div>

//         <Spacer classNames="h-5" />

//         <div className="mt-2 flex justify-between items-center">
//           <h2 className="font-bold">{title}</h2>
//           <h1 style={{ fontSize: '10px' }}>Max weight: {weight} kg</h1>
//         </div>

//         <div className="bg-gray-400 rounded-xl p-4 mt-4 shadow-inner">
//           <div className="flex justify-between w-full text-sm text-gray-700">
//             <div>
//               <p className="font-medium">0 pc/s left</p>
//               <p className="text-xs text-gray-500">To NCR</p>
//             </div>
//             <div>
//               <p className="font-medium">0 pc/s left</p>
//               <p className="text-xs text-gray-500">Outside NCR</p>
//             </div>
//           </div>
//         </div>

//         {/* ✅ HOVER CARD */}
//         <div className="absolute left-0 top-0 w-full h-full bg-white rounded-lg shadow-lg opacity-0 scale-95 
//           transition-all duration-300 pointer-events-none group-hover:opacity-100 group-hover:scale-100 
//           group-hover:pointer-events-auto flex flex-col z-50 p-4">
          
//           <div className="overflow-y-auto max-h-[350px]">
//             {/* ✅ TABLE */}
//             <table className="w-full table-fixed border-separate border-spacing-0 text-xs text-center rounded-lg overflow-hidden border border-black">
//               <thead className="bg-[#d00149] text-white">
//                 <tr className="border-b border-black">
//                   <th className="p-1 border border-0 rounded-tl-lg"></th>
//                   <th className="p-1 border border-0">NCR</th>
//                   <th className="p-1 border border-0 rounded-tr-lg">Outside NCR</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 <tr className="border-b border-black">
//                   <td className="p-1 border-b border-black rounded-tl-lg">Price per Bundle (25 pcs)</td>
//                   <td className="p-1 border-b border-black">{NCRPrice}</td>
//                   <td className="p-1 border-b border-black rounded-tl-lg">{OutSideNCR}</td>
//                 </tr>
//                 <tr className="border-b border-black">
//                   <td className="p-1 border-b border-black rounded-tl-lg">Inventory</td>
//                   <td className="p-1 border-b border-black">0</td>
//                   <td className="p-1 border-b border-black rounded-tl-lg">0</td>
//                 </tr>
//                 <tr className="border-b border-black">
//                   <td className="p-1 border border-0 rounded-tl-lg">Suitable to ship</td>
//                   <td colSpan="2" className="p-1 border border-0 rounded-tl-lg">
//                     {Description}
//                   </td>
//                 </tr>
//               </tbody>
//             </table>
//           </div>
          
//           {/* ✅ BUTTON TO OPEN MODAL */}
//           <div className="text-center mt-4">
//             <p className="text-sm text-gray-600 mb-2">Get your stocks now by clicking 'Order Now'.</p>

//             <Spacer className="h-14" />
//             <Button className="w-32 h-9 text-base px-4" onClick={() => setIsModalOpen(true)}>
//               Add to Bag
//             </Button>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

export const PackageCard = ({
  image,
  title,
  size,
  weight,
  NCRPrice,
  OutSideNCR,
  Description,
  onOrderNow // 🔥 this will trigger parent to open the OrderModal
}) => {
  const handleOrderClick = () => {
    const packageData = {
      image,
      prodDisplayName: title,
      size,
      weight,
      NCRPrice,
      OutSideNCR,
      Description
    };

    onOrderNow(packageData); // Call parent to open modal with selected data
  };

  return (
    <div className="relative bg-white rounded-xl p-4 shadow-lg text-center w-full max-w-[300px] group overflow-hidden">
      <div className="relative">
        <img src={image} alt={title} className="w-full h-[160px] object-contain mb-2" />
      </div>

      <Spacer classNames="h-5" />

      <div className="mt-2 flex justify-between items-center">
        <h2 className="font-bold">{title}</h2>
        <h1 style={{ fontSize: '10px' }}>Max weight: {weight} kg</h1>
      </div>

      <div className="bg-gray-400 rounded-xl p-4 mt-4 shadow-inner">
        <div className="flex justify-between w-full text-sm text-gray-700">
          <div>
            <p className="font-medium">0 pc/s left</p>
            <p className="text-xs text-gray-500">To NCR</p>
          </div>
          <div>
            <p className="font-medium">0 pc/s left</p>
            <p className="text-xs text-gray-500">Outside NCR</p>
          </div>
        </div>
      </div>

      {/* ✅ HOVER CARD */}
      <div className="absolute left-0 top-0 w-full h-full bg-white rounded-lg shadow-lg opacity-0 scale-95 
        transition-all duration-300 pointer-events-none group-hover:opacity-100 group-hover:scale-100 
        group-hover:pointer-events-auto flex flex-col z-50 p-4">
        
        <div className="overflow-y-auto max-h-[350px]">
          {/* ✅ TABLE */}
          <table className="w-full table-fixed border-separate border-spacing-0 text-xs text-center rounded-lg overflow-hidden border border-black">
            <thead className="bg-[#d00149] text-white">
              <tr className="border-b border-black">
                <th className="p-1 border border-0 rounded-tl-lg"></th>
                <th className="p-1 border border-0">NCR</th>
                <th className="p-1 border border-0 rounded-tr-lg">Outside NCR</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b border-black">
                <td className="p-1 border-b border-black rounded-tl-lg">Price per Bundle (25 pcs)</td>
                <td className="p-1 border-b border-black">{NCRPrice}</td>
                <td className="p-1 border-b border-black rounded-tl-lg">{OutSideNCR}</td>
              </tr>
              <tr className="border-b border-black">
                <td className="p-1 border-b border-black rounded-tl-lg">Inventory</td>
                <td className="p-1 border-b border-black">0</td>
                <td className="p-1 border-b border-black rounded-tl-lg">0</td>
              </tr>
              <tr className="border-b border-black">
                <td className="p-1 border border-0 rounded-tl-lg">Suitable to ship</td>
                <td colSpan="2" className="p-1 border border-0 rounded-tl-lg">
                  {Description}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* ✅ BUTTON TO OPEN MODAL */}
        <div className="text-center mt-4">
          <p className="text-sm text-gray-600 mb-2">Get your stocks now by clicking 'Order Now'.</p>

          <Spacer className="h-14" />
          <Button className="w-32 h-9 text-base px-4" onClick={handleOrderClick}>
            Add to Bag
          </Button>
        </div>
      </div>
    </div>
  );
};

export const RequestItems = ({ data }) => {
  const [newCount, setCount] = React.useState(1);

  const updateCount = (ascending) => {
    if (newCount === 0 && ascending) {
      setCount(newCount + 1);
    } else if (newCount === 0 && !ascending) {
      //
    } else if (newCount > 0 && ascending) {
      setCount(newCount + 1);
      data.quantity = parseInt(data.quantity) + 1;
    } else if (newCount > 0 && !ascending) {
      setCount(newCount - 1);
      data.quantity = parseInt(data.quantity) - 1;
    }
  };

  const updateCountOnInput = (event) => {
    setCount(parseInt(event.target.value));
    data.quantity = parseInt(event.target.value);
  };

  const deleteBin = () => {
    setCount(0);
    data.quantity = 0;
  };

  return (
    <FlexRow className="w-full items-center justify-between py-2">
      <RawButton onClick={() => deleteBin()}>
        <RiDeleteBin6Line className="text-red-400 text-xl ml-2" />
      </RawButton>
      <Text className="text-secondary-100 break-words">{data.name}</Text>
      <FlexRow className="w-2/5 items-center justify-around">
        <RawButton
          className="text-red-400 font-bold border-2 border-red-400 rounded-lg mx-1 w-8 h-8 flex items-center justify-center hover:bg-red-300"
          onClick={() => updateCount(false)}
        >
          <FaMinus />
        </RawButton>
        {/*<Text className="text-secondary-100 px-2">{newCount}</Text>*/}
        {/*<RawInput
          className="text-secondary-100 px-2"
          containerClass="w-1/3 pr-2"
          name="newCount"
          placeholder="Quantity"
          type="text"
          value={newCount}
          onChange={(value) => updateCountOnInput(value)}
        />*/}
        <div className="w-1/3 pr-2">
          <input
            type="text"
            className={classNames(
              `border ${"border-grey-400"
              } rounded-lg block w-full`,
              "text-secondary-100 px-2"
            )}
            id="newCount"
            name="newCount"
            placeholder="Quantity"
            value={newCount}
            onChange={(event) => updateCountOnInput(event)}
            style={{ textAlign: 'center' }}>
          </input>
        </div>
        <RawButton
          className="text-red-400 font-bold border-2 border-red-400 rounded-lg mx-1 w-8 h-8 flex items-center justify-center hover:bg-red-300"
          onClick={() => updateCount(true)}
        >
          <FaPlus />
        </RawButton>
      </FlexRow>
    </FlexRow>
  );
};
